var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trending-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sliders-container occasion" },
      [
        _c(
          "VueSlickCarousel",
          {
            attrs: {
              infinite: true,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1
            },
            scopedSlots: _vm._u([
              {
                key: "prevArrow",
                fn: function(arrowOption) {
                  return [
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648"
                        }
                      })
                    ])
                  ]
                }
              },
              {
                key: "nextArrow",
                fn: function(arrowOption) {
                  return [
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648"
                        }
                      })
                    ])
                  ]
                }
              }
            ])
          },
          [
            _vm._v(" "),
            _vm._l(_vm.slides, function(slide) {
              return _c("div", { staticClass: "trending-slide" }, [
                _c("div", { staticClass: "content-container" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v(_vm._s(slide.title))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "subtitle" }, [
                    _vm._v(_vm._s(slide.content))
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "happybox-button green border",
                      attrs: { href: slide.link_url }
                    },
                    [_vm._v(_vm._s(slide.button_name))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "image-container" }, [
                  _c("img", {
                    staticClass: "lazyload",
                    attrs: { src: slide.image_url }
                  })
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "title mobile" }, [
                  _vm._v(_vm._s(slide.title))
                ])
              ])
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "trending-title-container" }, [
      _c("span", [_vm._v("BLOG")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }